import { useState, useEffect } from 'react';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import Missions from './pages/Missions';
import Leaderboard from './pages/Leaderboard';
import { api } from './services/api';
import './App.css';

const TABS = ['dashboard', 'chat', 'missions', 'leaderboard'];
const TAB_ICONS = { dashboard: '⚔️', chat: '🧠', missions: '🔥', leaderboard: '🏆' };
const TAB_LABELS = { dashboard: 'Profilo', chat: 'Coach AI', missions: 'Missioni', leaderboard: 'Classifica' };

export default function App() {
  const [userId, setUserId]         = useState(() => localStorage.getItem('detox_userId'));
  const [profile, setProfile]       = useState(null);
  const [activeTab, setActiveTab]   = useState('dashboard');
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstall, setShowInstall]     = useState(false);

  // Cattura evento PWA install
  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setInstallPrompt(e); setShowInstall(true); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  useEffect(() => {
    if (!userId) {
      api.register().then(res => {
        const id = res.data.id;
        localStorage.setItem('detox_userId', id);
        setUserId(id);
        setProfile(res.data);
      });
    } else {
      api.getProfile(userId).then(res => setProfile(res.data));
    }
  }, [userId]);

  async function handleInstall() {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') setShowInstall(false);
  }

  if (!profile) {
    return (
      <div className="loading">
        <div className="loading-icon">⚔️</div>
        <p>Inizializzazione profilo guerriero...</p>
      </div>
    );
  }

  const AVATAR_EMOJIS = ['🧟','😰','🥊','⚔️','🧘'];

  const pages = {
    dashboard:   <Dashboard profile={profile} setProfile={setProfile} userId={userId} />,
    chat:        <Chat      userId={userId}   setProfile={setProfile} />,
    missions:    <Missions  userId={userId}   profile={profile}       setProfile={setProfile} />,
    leaderboard: <Leaderboard userId={userId} />,
  };

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-avatar">{AVATAR_EMOJIS[profile.avatarTier]}</div>
        <div className="header-info">
          <span className="header-nick">{profile.nickname}</span>
          <span className="header-level">Lv.{profile.level} · {profile.xp} XP</span>
        </div>
        <div className="header-streak">🔥 {profile.streakDays}d</div>
      </header>

      <main className="app-content">
        {/* Banner installa PWA */}
        {showInstall && (
          <div className="install-banner">
            <span style={{fontSize:28}}>📲</span>
            <div className="install-banner-text">
              <strong>Installa DetoxWarrior</strong>
              Accedi più veloce dalla schermata home
            </div>
            <button className="install-btn" onClick={handleInstall}>Installa</button>
          </div>
        )}
        {pages[activeTab]}
      </main>

      <nav className="bottom-nav">
        {TABS.map(tab => (
          <button key={tab} className={`nav-btn ${activeTab === tab ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab)}>
            <span className="nav-icon">{TAB_ICONS[tab]}</span>
            <span className="nav-label">{TAB_LABELS[tab]}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
